const faqs = [
  {
    q: '小辣椒影院的视频画质怎么样？',
    a: '小辣椒影院所有影视资源均采用高清片源，支持 720P、1080P 高清画质在线播放。得益于先进的视频加速技术，播放流畅不卡顿，让你享受影院级的观影体验。部分热门影片还提供超清 4K 画质选项。',
  },
  {
    q: '在小辣椒影院看电影需要注册或付费吗？',
    a: '完全不需要！小辣椒影院是一个免费的影视网站，所有电影、电视剧、综艺和动漫资源均可免费在线观看，无需注册账号，也无需支付任何费用。打开网站即可直接开始观影，没有任何隐藏消费。',
  },
  {
    q: '网站更新频率如何？新片多久能上线？',
    a: '小辣椒影院的资源更新非常及时，每日更新 50 部以上的新片和热播剧集。院线电影下映后通常 1-2 周内上线，热门电视剧当日更新集数同步上线，确保你能第一时间追到最新内容。',
  },
  {
    q: '手机上可以观看吗？对设备有什么要求？',
    a: '小辣椒影院完美适配手机、平板和电脑等多种设备。无需下载任何 APP 或插件，通过手机浏览器访问即可流畅观影。网站采用自适应设计，在不同屏幕尺寸下都能提供舒适的观看体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">常见问题</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">关于小辣椒影院的常见疑问，这里都有解答</p>
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div key={faq.q} className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">{faq.q}</h3>
              <p className="text-sm text-foreground-700 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}